module.exports = __webpack_public_path__ + "media/images/flags/1x1/lao-08e7eaf70dade2a6264a32a8dea992e5.svg";